<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')" fullscreen>
        <v-card-text>
            <surveys-form ref="form" :value="form" readonly/>
        </v-card-text>
  </crud-show>
</template>

<script>
    import SurveysForm from "../../../../forms/SurveysForm/SurveysForm.vue";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "SurveyShow",
        components: {CrudShow, SurveysForm},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.surveys.showing',
                loading: false,
                form: {
                    name: '',
                    description: '',
                    questions: []
                }
            }
        },
        mounted(){
            this.form = {
                name: this.item.name,
                description: this.item.description,
                questions: this.item.questions.map(q => ({
                    question: q.question,
                    isFreeResponse: q.isFreeResponse,
                    options: q.options,
                    isOpen: false
                }))
            }
        }
    }
</script>

